module.exports = __webpack_public_path__ + "media/images/flags/16/Cameroon-8f533a49ac9946095aa286c44db60f38.png";